(ns ui.components.badge.view
  (:require))

(defn danger
  [{:keys [label]}]
  [:span
   {:class "inline-block py-1 px-2 bg-danger-light text-danger-light-text text-xs rounded"}
   label])

(defn warning
  [{:keys [label]}]
  [:span
   {:class "inline-block py-1 px-2 bg-warning-light text-warning-light-text text-xs rounded"}
   label])

(defn success
  [{:keys [label]}]
  [:span
   {:class "inline-block py-1 px-2 bg-success-light text-success-light-text text-xs rounded"}
   label])

(defn neutral
  "For a state that is simply what it is - neither good news nor a problem.
   Without it, an ordinary in-progress status has to borrow `warning` and reads
   as something the user should act on."
  [{:keys [label]}]
  [:span
   {:class "inline-block py-1 px-2 bg-base-light-border-paler text-base-light-text-lighter text-xs rounded"}
   label])
